import { createAction, props } from '@ngrx/store';
import { ProjektDaten } from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';
import {ProjektItem} from '../../../projektverwaltung/projekt.model';
import {NodeItem} from '../../../projektverwaltung/node.model';

export const loadProjektSelectboxStart = createAction('ZEIT::PROJECTSSELECTBOX_LOAD_START', props<{projektId: number }>(), );
export const loadProjektSelectboxSucceeded = createAction('ZEIT::PROJECTSSELECTBOX_LOAD_SUCCEEDED',
  props<{ projektDaten: NodeItem[] }>(),
);
export const loadProjektSelectboxFailed = createAction('ZEIT::PROJECTSSELECTBOX_LOAD_FAILED');
